import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const location = useLocation();
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <div className="min-h-screen flex flex-col" data-id="element-163">
      <Header data-id="element-164" />
      <main className="flex-grow" data-id="element-165">{children}</main>
      <Footer data-id="element-166" />
    </div>;
}